<template>

  <RidSddBanche />

</template>

<script>
import RidSddBanche from '../components/pratiche/RidSddBanche.vue'

export default {
  components: {
    RidSddBanche
  },
  data() {
    return {

    }
  },

  created(){

  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {

  },
}
</script>
